import ChaptersList from "../../components/chapters/ChaptersList";
import AddChapter from "../../components/chapters/AddChapter";
import ProjectHeader from "../../components/common/ProjectHeader/ProjectHeader";
import CalendarHeatmap from "react-calendar-heatmap";
import { Tooltip } from 'react-tooltip';
import { useParams, useNavigate } from "react-router-dom";
import { useProject } from "../../hooks/useProject";
import { useEffect, useRef } from "react";
import { Chart } from "chart.js/auto";
import { IoIosArrowBack } from "react-icons/io";
import '../../styles/StatsCharts.css'
import "react-calendar-heatmap/dist/styles.css"; 
import { Link } from "react-router-dom";

export default function ProjectStats(){
    const {project, updateProject, index} = useProject();

    const navigate = useNavigate();
    const WordsChart = useRef(null);
    const TotalWordsChart = useRef(null);


    useEffect(() => {

    const ctx = WordsChart.current;
    const labels = project.history.map(item => item.date);
    const data = project.history.map(item => item.words);
    const chart = new Chart(ctx, {
      type: 'line',
      data: {
        labels: labels,
        datasets: [{
          label: 'Historia',
          data: data,
          borderColor: 'rgb(107, 32, 145)',
          tension: 0
        }]
      }
    });

    return () => {
      chart.destroy(); 
    };
    
  }, [project.history]);

    useEffect(() => {
    let currentWords = 0;
    const ctx = TotalWordsChart.current;
    const labels = project.history.map(item => item.date);
    const data = project.history.map( item => {
      currentWords += item.words
      return currentWords;
    }
    );
    const chart = new Chart(ctx, {
      type: 'line',
      data: {
        labels: labels,
        datasets: [{
          label: 'Liczba słów w projekcie',
          data: data,
          borderColor: 'rgb(190, 136, 217)',
          tension: 0
        }]
      }
    });

    return () => {
      chart.destroy(); 
    };
    
  }, [project.history]);

  

    return(
        <div>

              <ProjectHeader
              headerTitle={"Statystyki"}
              showBackButton={true}
              path={`/offline/project/${index}`}
              />
              <div className="StatsCharts" style={{marginTop: '100px'}} > 
                <div style={{ width: "500px" }}>
                  <canvas ref={WordsChart}></canvas>
                </div>
                <div style={{ width: "500px" }}>
                  <canvas ref={TotalWordsChart}></canvas>
                </div>
              </div>
            
            {project.settings.chaptersEnabled && (
              <div className="chapters-box"> 
                <ChaptersList
                project={project}
                updateProject={updateProject}/>
                <AddChapter
                project={project}
                updateProject={updateProject}/>
              </div>
            )}

            <button onClick={() => navigate(`/offline/project/${index}`)}>Wróć</button>
        </div>
    )
}